import {
  BodySizeData,
  MeasurementGuidesMap,
  SizeConfigMap,
  SizeDataMap,
} from '@/types/size'

export const PRODUCT_SIZE: Record<string, string> = {
  '67ac49a470b8511ed6c7710d': 'BRA',
  '67ac512f70b8511ed6c77113': 'LEGGING',
  '67ac574570b8511ed6c7711d': 'SHIRT',
  '67c03249d0a61fdaefc2cf13': 'PANTS',
  '67c662fe721dc23266e7b1d6': 'SHORTS',
  '684f7891d1de2819b1a0b1b8': 'DRESS',
}

// Data cho hướng dẫn chọn độ dài Legging
export const LEGGING_LENGTH_GUIDE = {
  title: 'Hướng dẫn chọn độ dài',
  rows: [
    {
      name: 'Chiều dài ống* (cm)',
      id: 1,
    },
  ],
  columns: [
    {
      name: 'Full',
      id: 1,
    },
    {
      name: '7/8',
      id: 2,
    },
    {
      name: 'Capri',
      id: 3,
    },
  ],
  headerRow: 'Chiều dài',
  matrix: [
    { rowId: 1, columnId: 1, value: '69 - 71' },
    { rowId: 1, columnId: 2, value: '61 - 63' },
    { rowId: 1, columnId: 3, value: '52.5 - 53.5' },
  ],
  descriptions: [
    { type: 'Full length', description: 'Dài dưới mắt cá chân' },
    { type: 'Dài 7/8', description: 'Dài trên mắt cá chân' },
    { type: 'Capri', description: 'Dài đến bắp chân dưới' },
  ],
  note: '* Chiều dài ống quần nằm ở phía trong, tính từ đáy quần đến gấu quần.',
}

export const SIZE_DATA: SizeDataMap = {
  BRA: {
    rows: [
      {
        name: '65-68',
        id: 1,
      },
      {
        name: '69-73',
        id: 2,
      },
      {
        name: '74-78',
        id: 3,
      },
      {
        name: '79-83',
        id: 4,
      },
      {
        name: '84-87',
        id: 5,
      },
    ],
    columns: [
      {
        name: '75-81',
        id: 1,
      },
      {
        name: '82-85',
        id: 2,
      },
      {
        name: '86-90',
        id: 3,
      },
      {
        name: '91-95',
        id: 4,
      },
      {
        name: '96-100',
        id: 5,
      },
    ],
    headerTitle: 'VÒNG NGỰC',
    leftTitle: 'Chân ngực',
    matrix: [
      { rowId: 1, columnId: 1, value: 'XS' },
      { rowId: 2, columnId: 1, value: 'XS' },
      { rowId: 1, columnId: 2, value: 'XS' },
      { rowId: 2, columnId: 2, value: 'S' },
      { rowId: 3, columnId: 2, value: 'S' },
      { rowId: 1, columnId: 3, value: 'S' },
      { rowId: 2, columnId: 3, value: 'S' },
      { rowId: 3, columnId: 3, value: 'M' },
      { rowId: 4, columnId: 3, value: 'L' },
      { rowId: 2, columnId: 4, value: 'M' },
      { rowId: 3, columnId: 4, value: 'M' },
      { rowId: 4, columnId: 4, value: 'L' },
      { rowId: 5, columnId: 4, value: 'L' },
      { rowId: 3, columnId: 5, value: 'L' },
      { rowId: 4, columnId: 5, value: 'XL' },
      { rowId: 5, columnId: 5, value: 'XL' },
    ],
  },
  LEGGING: {
    rows: [
      {
        name: '80-84',
        id: 1,
      },
      {
        name: '85-89',
        id: 2,
      },
      {
        name: '90-94',
        id: 3,
      },
      {
        name: '95-99',
        id: 4,
      },
      {
        name: '100-104',
        id: 5,
      },
    ],
    columns: [
      {
        name: '58-64',
        id: 1,
      },
      {
        name: '65-71',
        id: 2,
      },
      {
        name: '72-77',
        id: 3,
      },
      {
        name: '78-85',
        id: 4,
      },
      {
        name: '86-94',
        id: 5,
      },
    ],
    headerTitle: 'VÒNG EO',
    leftTitle: 'Vòng mông',
    matrix: [
      { rowId: 1, columnId: 1, value: 'XS' },
      { rowId: 2, columnId: 1, value: 'XS' },
      { rowId: 3, columnId: 1, value: 'S' },
      { rowId: 4, columnId: 1, value: 'S' },
      { rowId: 1, columnId: 2, value: 'XS' },
      { rowId: 2, columnId: 2, value: 'S' },
      { rowId: 3, columnId: 2, value: 'S' },
      { rowId: 4, columnId: 2, value: 'M' },
      { rowId: 5, columnId: 2, value: 'M' },
      { rowId: 1, columnId: 3, value: 'S' },
      { rowId: 2, columnId: 3, value: 'M' },
      { rowId: 3, columnId: 3, value: 'M' },
      { rowId: 4, columnId: 3, value: 'M' },
      { rowId: 5, columnId: 3, value: 'L' },
      { rowId: 2, columnId: 4, value: 'M' },
      { rowId: 3, columnId: 4, value: 'L' },
      { rowId: 4, columnId: 4, value: 'L' },
      { rowId: 5, columnId: 4, value: 'XL' },
      { rowId: 3, columnId: 5, value: 'L' },
      { rowId: 4, columnId: 5, value: 'XL' },
      { rowId: 5, columnId: 5, value: 'XL' },
    ],
  },
}

export const MEASUREMENT_GUIDES: MeasurementGuidesMap = {
  BRA: {
    video: {
      url: 'https://media3.coolmate.me/uploads/videos/chon-size-bra-abc.mp4',
      thumbnail:
        'https://media3.coolmate.me/uploads/videos/chon-size-bra-abc.mp4',
    },
    steps: [
      {
        image: '/image/March2025/mceclip0_23.png',
        title: 'BƯỚC 1: CHUẨN BỊ',
        description:
          'Hãy mặc một chiếc áo bra không đệm và không gọng và một chiếc thước dây để đo chính xác hơn nhé.',
      },
      {
        image: '/image/March2025/mceclip1_2.png',
        title: 'BƯỚC 2: ĐO CHÂN NGỰC',
        description:
          'Giữ một đầu của thước dây ở phía trước và chính giữa, ngay bên dưới ngực của bạn. Kéo thước dây quanh lưng của bạn để gặp đầu phía trước của thước dây và ghi lại số đo này.',
      },
      {
        image: '/image/March2025/mceclip2_77.png',
        title: 'BƯỚC 3: ĐO VÒNG NGỰC',
        description:
          'Bước này đo vòng ngực của bạn, hoặc kích thước cúp ngực. Giữ đầu thước dây ở giữa một lần nữa nhưng lần này hãy đo quanh phần đầy nhất của ngực bạn. Đừng kéo quá chặt nhé. Hãy ghi lại số đo này.',
      },
    ],
    measurementPoints: [
      {
        number: 1,
        title: 'Vòng ngực',
        description:
          'Số đo khi bạn đo vùng đầy đặn nhất của ngực bạn, khi giữ thước dây đo theo chiều ngang',
      },
      {
        number: 2,
        title: 'Vòng chân ngực',
        description:
          'Số đo khi bạn đo vùng ngay dưới ngực của bạn, khi giữ thước dây đo chiều ngang. ',
      },
    ],
    illustration: '/image/March2025/mceclip1_33.png',
  },
  LEGGING: {
    video: {
      url: 'https://media3.coolmate.me/uploads/videos/chon-size-quan-abc.mp4',
      thumbnail:
        'https://media3.coolmate.me/uploads/videos/chon-size-quan-abc.mp4',
    },
    steps: [
      {
        image: '/image/March2025/mceclip0_81.png',
        title: 'BƯỚC 1: CHUẨN BỊ',
        description:
          'Hãy mặc một chiếc quần leggings hoặc một chiếc quần mỏng và chuẩn bị một chiếc thước dây để đo chính xác hơn nhé.',
      },
      {
        image: '/image/March2025/mceclip2_86.png',
        title: 'BƯỚC 2: ĐO VÒNG EO',
        description:
          'Giữ một đầu của thước dây ở phía trước và chính giữa, ngay vùng hẹp nhất của eo bạn. Kéo thước dây quanh eo của bạn để gặp đầu phía trước của thước dây và ghi lại số đo này.',
      },
      {
        image: '/image/March2025/mceclip1_72.png',
        title: 'BƯỚC 3: ĐO VÒNG MÔNG',
        description:
          'Hãy đứng thẳng và khép chân, giữ một đầu của thước dây ở phía trước và chính giữa, ngay vùng rộng nhất của mông bạn. Kéo thước dây quanh mông của bạn để gặp đầu phía trước của thước dây và ghi lại số đo này. Đừng kéo chặt quá nhé.',
      },
      {
        image: '/image/March2025/mceclip3_76.png',
        title: 'BƯỚC 4: ĐO CHIỀU DÀI SƯỜN TRONG',
        description:
          'Hãy đứng thẳng và khép chân, đo phần chiều dài từ đáy quần đến chạm đất và ghi lại số đo này.',
      },
    ],
    measurementPoints: [
      {
        number: 1,
        title: 'Vòng eo',
        description: 'Số đo vùng hẹp nhất của eo bạn.',
      },
      {
        number: 2,
        title: 'Vòng mông',
        description:
          'Số đo vùng rộng nhất của mông bạn khi đứng thẳng và khép chân',
      },
      {
        number: 3,
        title: 'Chiều dài sườn trong',
        description:
          'Số đo phần chiều dài từ đáy quần đến chạm đất khi bạn đứng thẳng và khép chân.',
      },
    ],
    illustration: '/image/March2025/mceclip0_47.png',
  },
}

export const SIZE_CONFIG: SizeConfigMap = {
  BRA: {
    xAxis: 'bust',
    yAxis: 'underbust',
    xAxisLabel: 'Vòng ngực',
    yAxisLabel: 'Chân ngực',
    minXAxis: 78,
    maxXAxis: 100,
    minYAxis: 65,
    maxYAxis: 87,
    unitX: 'cm',
    unitY: 'cm',
  },
  LEGGING: {
    xAxis: 'waist',
    yAxis: 'hips',
    xAxisLabel: 'Vòng eo',
    yAxisLabel: 'Vòng mông',
    minXAxis: 58,
    maxXAxis: 94,
    minYAxis: 80,
    maxYAxis: 104,
    unitX: 'cm',
    unitY: 'cm',
  },
}

const heightWeightConfig = {
  xAxis: 'height',
  yAxis: 'weight',
  xAxisLabel: 'Chiều cao',
  yAxisLabel: 'Cân nặng',
  minXAxis: 145,
  maxXAxis: 175,
  minYAxis: 40,
  maxYAxis: 65,
  unitX: 'cm',
  unitY: 'kg',
}

SIZE_CONFIG.SHIRT = heightWeightConfig
SIZE_CONFIG.PANTS = heightWeightConfig
SIZE_CONFIG.SHORTS = heightWeightConfig
SIZE_CONFIG.DRESS = heightWeightConfig

export const BODY_SIZE: BodySizeData = {
  rows: [
    {
      name: 'Vòng ngực',
      id: 1,
    },
    {
      name: 'Vòng eo',
      id: 2,
    },
    {
      name: 'Vòng mông',
      id: 3,
    },
    {
      name: 'Cân nặng tham khảo (kg)',
      id: 4,
    },
  ],
  columns: [
    {
      name: 'XS',
      id: 1,
    },
    {
      name: 'S',
      id: 2,
    },
    {
      name: 'M',
      id: 3,
    },
    {
      name: 'L',
      id: 4,
    },
    {
      name: 'XL',
      id: 5,
    },
  ],
  matrix: [
    {
      rowId: 1,
      columnId: 1,
      value: '75~81',
    },
    {
      rowId: 1,
      columnId: 2,
      value: '82~85',
    },
    {
      rowId: 1,
      columnId: 3,
      value: '86~90',
    },
    {
      rowId: 1,
      columnId: 4,
      value: '91~95',
    },
    {
      rowId: 1,
      columnId: 5,
      value: '96~100',
    },
    {
      rowId: 2,
      columnId: 1,
      value: '58~64',
    },
    {
      rowId: 2,
      columnId: 2,
      value: '65~71',
    },
    {
      rowId: 2,
      columnId: 3,
      value: '72~77',
    },
    {
      rowId: 2,
      columnId: 4,
      value: '78~85',
    },
    {
      rowId: 2,
      columnId: 5,
      value: '86~94',
    },
    {
      rowId: 3,
      columnId: 1,
      value: '80~84',
    },
    {
      rowId: 3,
      columnId: 2,
      value: '85~89',
    },
    {
      rowId: 3,
      columnId: 3,
      value: '90~94',
    },
    {
      rowId: 3,
      columnId: 4,
      value: '95~99',
    },
    {
      rowId: 3,
      columnId: 5,
      value: '100~104',
    },
    {
      rowId: 4,
      columnId: 1,
      value: '40~45',
    },
    {
      rowId: 4,
      columnId: 2,
      value: '45~50',
    },
    {
      rowId: 4,
      columnId: 3,
      value: '50~55',
    },
    {
      rowId: 4,
      columnId: 4,
      value: '55~60',
    },
    {
      rowId: 4,
      columnId: 5,
      value: '60~65',
    },
  ],
}

export const SIZE_DATA_OLD = {
  BRA: {
    headerTitle: 'BẢNG SIZE SPORT BRA',
    leftTitle: 'Chỉ số cơ thể',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'Cup' },
      { id: 2, name: 'Vòng ngực' },
      { id: 3, name: 'Chân ngực' },
      { id: 4, name: 'Cân nặng\ntham khảo (kg)' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: 'B' },
      { rowId: 1, columnId: 2, value: 'B' },
      { rowId: 1, columnId: 3, value: 'B' },
      { rowId: 1, columnId: 4, value: 'B' },
      { rowId: 1, columnId: 5, value: 'B' },
      { rowId: 2, columnId: 1, value: '75-81' },
      { rowId: 2, columnId: 2, value: '82-85' },
      { rowId: 2, columnId: 3, value: '86-90' },
      { rowId: 2, columnId: 4, value: '91-95' },
      { rowId: 2, columnId: 5, value: '96-100' },
      { rowId: 3, columnId: 1, value: '65-68' },
      { rowId: 3, columnId: 2, value: '69-73' },
      { rowId: 3, columnId: 3, value: '74-78' },
      { rowId: 3, columnId: 4, value: '79-83' },
      { rowId: 3, columnId: 5, value: '84-87' },
      { rowId: 4, columnId: 1, value: '40-45' },
      { rowId: 4, columnId: 2, value: '45-50' },
      { rowId: 4, columnId: 3, value: '50-55' },
      { rowId: 4, columnId: 4, value: '55-60' },
      { rowId: 4, columnId: 5, value: '60-65' },
    ],
  },
  LEGGING: {
    headerTitle: 'BẢNG SIZE LEGGING',
    leftTitle: 'Chỉ số cơ thể',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'Quy đổi\nquốc tế:US' },
      { id: 2, name: 'Vòng eo' },
      { id: 3, name: 'Vòng mông' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '0-2' },
      { rowId: 1, columnId: 2, value: '4-6' },
      { rowId: 1, columnId: 3, value: '8-10' },
      { rowId: 1, columnId: 4, value: '12-14' },
      { rowId: 1, columnId: 5, value: '16-18' },
      { rowId: 2, columnId: 1, value: '58-64' },
      { rowId: 2, columnId: 2, value: '65-71' },
      { rowId: 2, columnId: 3, value: '72-77' },
      { rowId: 2, columnId: 4, value: '78-85' },
      { rowId: 2, columnId: 5, value: '86-94' },
      { rowId: 3, columnId: 1, value: '80-84' },
      { rowId: 3, columnId: 2, value: '85-89' },
      { rowId: 3, columnId: 3, value: '90-94' },
      { rowId: 3, columnId: 4, value: '95-99' },
      { rowId: 3, columnId: 5, value: '100-104' },
    ],
  },
  SHIRT: {
    headerTitle: 'BẢNG SIZE ÁO',
    leftTitle: 'Chỉ số cơ thể',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'Ngực' },
      { id: 2, name: 'Eo' },
      { id: 3, name: 'Mông' },
      { id: 4, name: 'Cân nặng (kg)' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '75-81' },
      { rowId: 1, columnId: 2, value: '82-85' },
      { rowId: 1, columnId: 3, value: '86-90' },
      { rowId: 1, columnId: 4, value: '91-95' },
      { rowId: 1, columnId: 5, value: '96-100' },
      { rowId: 2, columnId: 1, value: '58-64' },
      { rowId: 2, columnId: 2, value: '65-71' },
      { rowId: 2, columnId: 3, value: '72-77' },
      { rowId: 2, columnId: 4, value: '78-85' },
      { rowId: 2, columnId: 5, value: '86-94' },
      { rowId: 3, columnId: 1, value: '80-84' },
      { rowId: 3, columnId: 2, value: '85-89' },
      { rowId: 3, columnId: 3, value: '90-94' },
      { rowId: 3, columnId: 4, value: '95-99' },
      { rowId: 3, columnId: 5, value: '100-104' },
      { rowId: 4, columnId: 1, value: '40-45' },
      { rowId: 4, columnId: 2, value: '45-50' },
      { rowId: 4, columnId: 3, value: '50-55' },
      { rowId: 4, columnId: 4, value: '55-60' },
      { rowId: 4, columnId: 5, value: '60-65' },
    ],
  },
  PANTS: {
    headerTitle: 'BẢNG SIZE QUẦN',
    leftTitle: 'Chỉ số cơ thể',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'Eo' },
      { id: 2, name: 'Mông' },
      { id: 3, name: 'Chiều dài \n sừơn trong' },
      { id: 4, name: 'Cân nặng (kg)' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '58-64' },
      { rowId: 1, columnId: 2, value: '65-71' },
      { rowId: 1, columnId: 3, value: '72-77' },
      { rowId: 1, columnId: 4, value: '78-85' },
      { rowId: 1, columnId: 5, value: '86-94' },
      { rowId: 2, columnId: 1, value: '80-84' },
      { rowId: 2, columnId: 2, value: '85-89' },
      { rowId: 2, columnId: 3, value: '90-94' },
      { rowId: 2, columnId: 4, value: '95-99' },
      { rowId: 2, columnId: 5, value: '100-104' },
      { rowId: 3, columnId: 1, value: '72' },
      { rowId: 3, columnId: 2, value: '73' },
      { rowId: 3, columnId: 3, value: '74' },
      { rowId: 3, columnId: 4, value: '74.5' },
      { rowId: 3, columnId: 5, value: '75 ' },
      { rowId: 4, columnId: 1, value: '40-45' },
      { rowId: 4, columnId: 2, value: '45-50' },
      { rowId: 4, columnId: 3, value: '50-55' },
      { rowId: 4, columnId: 4, value: '55-60' },
      { rowId: 4, columnId: 5, value: '60-65' },
    ],
  },
  SHORTS: {
    headerTitle: 'BẢNG SIZE QUẦN SHORTS',
    leftTitle: 'Chỉ số cơ thể',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'Eo' },
      { id: 2, name: 'Mông' },
      { id: 3, name: 'Cân nặng (kg)' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '58-64' },
      { rowId: 1, columnId: 2, value: '65-71' },
      { rowId: 1, columnId: 3, value: '72-77' },
      { rowId: 1, columnId: 4, value: '78-85' },
      { rowId: 1, columnId: 5, value: '86-94' },
      { rowId: 2, columnId: 1, value: '80-84' },
      { rowId: 2, columnId: 2, value: '85-89' },
      { rowId: 2, columnId: 3, value: '90-94' },
      { rowId: 2, columnId: 4, value: '95-99' },
      { rowId: 2, columnId: 5, value: '100-104' },
      { rowId: 3, columnId: 1, value: '40-45' },
      { rowId: 3, columnId: 2, value: '45-50' },
      { rowId: 3, columnId: 3, value: '50-55' },
      { rowId: 3, columnId: 4, value: '55-60' },
      { rowId: 3, columnId: 5, value: '60-65' },
    ],
  },
  DRESS: {
    headerTitle: 'BẢNG SIZE VÁY ĐẦM',
    leftTitle: 'Chỉ số cơ thể',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'Eo' },
      { id: 2, name: 'Mông' },
      { id: 3, name: 'Cân nặng (kg)' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '58-64' },
      { rowId: 1, columnId: 2, value: '65-71' },
      { rowId: 1, columnId: 3, value: '72-77' },
      { rowId: 1, columnId: 4, value: '78-85' },
      { rowId: 1, columnId: 5, value: '86-94' },
      { rowId: 2, columnId: 1, value: '80-84' },
      { rowId: 2, columnId: 2, value: '85-89' },
      { rowId: 2, columnId: 3, value: '90-94' },
      { rowId: 2, columnId: 4, value: '95-99' },
      { rowId: 2, columnId: 5, value: '100-104' },
      { rowId: 3, columnId: 1, value: '40-45' },
      { rowId: 3, columnId: 2, value: '45-50' },
      { rowId: 3, columnId: 3, value: '50-55' },
      { rowId: 3, columnId: 4, value: '55-60' },
      { rowId: 3, columnId: 5, value: '60-65' },
    ],
  },
}

export const DEMAND_OPTIONS = [
  { label: 'Chạy bộ', value: '67bfcb2f10f9da73764d6986' },
  { label: 'Thể thao', value: '67bfcad322460c30a43d192b' },
  { label: 'Yoga & Pilates', value: '67bfc94aa65c8e57d6390f14' },
]
